import React from 'react'
import { getImages } from '../Common/const'
import ContactForm from '../Common/ContactForm'
import UseScrollReveal from '../Common/UseScrollReveal'

const ContactUs = () => {
    UseScrollReveal()
  return (
    <>
        <section className='contact-wrap'
            style={{
                backgroundImage: `url(${getImages('contact-hero.webp')})`
            }}
        >
            <div className='container'>
                <div className='xl-title contact-title1 text-start text-uppercase letter-spacing-3 mb-3 wow reveal fadeInUp'>Contact Us</div>
                <div className='xs-title contact-title2 text-uppercase eurostile fw-300 font-1-4em letter-spacing-1 mb-md-5 mb-4 pb-md-4 wow reveal fadeInUp'>Drop us a line, we'd love to hear from you</div>
                <div className='row mlr-50'>
                    <div className='col-md-6 order-md-2 wow reveal fadeInUp'>
                        <ContactForm/>
                    </div>
                    <div className='col-md-6'>
                        <div className='contact-black-box wow reveal fadeIn'>
                            <div className='xs-title font-1-4em eurostile fw-bold mb-4 wow reveal fadeInUp'>AUSTIN OFFICE</div>
                            <div className='d-flex align-items-center mb-4 wow reveal fadeInUp'>
                                <div className='cb-icon'><img src={getImages('local-phone-material.png')}/></div> 
                                <div className='xs-title font-1-1em eurostile fw-bold'>512-777-1240</div>
                            </div>
                            <div className='d-flex align-items-center wow reveal fadeInUp'>
                                <div className='cb-icon'><img src={getImages('contact-location-icon.svg')}/></div> 
                                <div className='xs-title fw-400'>8140 N. Mopac Suite 4-150 Austin, TX 78759</div>
                            </div>
                        </div>
                        <div className='wow reveal fadeInUp'>
                            <iframe src="https://snazzymaps.com/embed/744745" width="100%" height="380px" style={{border:'none'}}></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default ContactUs